import { useState } from "react";
import "./Payment.css";
import PaymentCard from "./components/paymentCard/PaymentCard";
import PaymentSection from "./components/paymentSection/PaymentSection";
import CustomDialog from "../../../components/customDialog/CustomDialog";
import ModalHeader from "./components/modalHeader/ModalHeader";
// import ModalLaterBtn from "./components/modalLaterBtn/ModalLaterBtn";
// import AddMoneyNew from "./components/addMoney/AddMoneyNew";
// import AddBankCard from "./components/addMoney/AddBankCard";
// import AddBankCardOTP from "./components/addMoney/AddBankCardOTP";
// import AddMoneyPassword from "./components/addMoney/AddMoneyPassword";
// import AddMoneyAllCards from "./components/addMoney/AddMoneyAllCards";
// import Withdrawal from "./components/withdrawal/Withdrawal";
// import WithdrawalOTP from "./components/withdrawal/WithdrawalOTP";
// import WithdrawalSuccess from "./components/withdrawal/WithdrawalSuccess";
import CustomAutoComplete from "../../../components/customAutoComplete/CustomAutoComplete";
import ProfileEditInput from "../../../components/profileEditInput/ProfileEditInput";
import usePayments from "../../../hook/usePayments";
import { useTypedSelector } from "../../../hook/useTypedSelector";
import {
  useAddBankAccountMutation,
  useGetAccountQuery,
  useGetPaymentCardsQuery,
  useGetPaymentsHistoryQuery,
  useLazyVerifyAccountQuery,
  useUpdateBankAccountMutation,
} from "../../../store/query/payments";
import CustomButton from "../../../components/customButton/CustomButton";
import { toast } from "react-toastify";
import { _currency_format } from "../../../utils";
import moment from "moment";
import { Button } from "@mui/material";
import { GrPowerReset } from "react-icons/gr";
import PaginationContainer from "../../../components/paginationContainer/PaginationContainer";

const Payment = () => {
  const [showSetup, setShowSetup] = useState(false);
  const { user } = useTypedSelector((store) => store.appUser);
  // const [showAddMoney, setShowAddMoney] = useState(false);
  // const [showWithdraw, setShowWithdraw] = useState(false);
  // const [stepAddMoney, setStepAddMoney] = useState(1);
  // const [stepWithdraw, setStepWithdraw] = useState(1);
  const {
    data: account,
    isLoading: isAccounting,
    refetch,
  } = useGetAccountQuery({
    acc_type: user?.account_type,
  });
  //console.log(account);
  const [filters, setFilters] = useState({
    pay_type: user?.account_type === "individual" ? "payin" : "payout",
    page: 1,
  });
  const { data: histories, isLoading: isRetriving } =
    useGetPaymentsHistoryQuery({
      acc_type: user?.account_type,
      ...filters,
    });

  const { data: cards } = useGetPaymentCardsQuery({
    acc_type: user?.account_type,
  });

  const options =
    user?.account_type === "individual"
      ? [
          { label: "Received Payments History", value: "payin" },
          { label: "Payout History", value: "payout" },
          // { label: "Refund Payments History", value: "refund" },
        ]
      : [
          { label: "Payout History", value: "payout" },
          { label: "Refund Payments History", value: "refund" },
        ];

  const statusOptions =
    user?.account_type === "individual"
      ? [
          { label: "All", value: 0 },
          { label: "Pending", value: 1 },
          { label: "Processed", value: 4 },
        ]
      : [
          { label: "All", value: 0 },
          { label: "Pending", value: 1 },
          { label: "Processed", value: 4 },
          { label: "Refund", value: 5 },
        ];

  const initOption = options.filter(
    (option) => option.value === filters.pay_type
  )[0];

  //console.log("history", histories);
  const paymentHistory = histories?.data?.data;

  const handleClose = () => {
    //setShowAddMoney(false);
    setShowSetup(false);
    refetch();
    // setShowWithdraw(false);
    // setStepAddMoney(1);
    // setStepWithdraw(1);
  };

  // const addMoneyModal = () => {
  //   switch (stepAddMoney) {
  //     case 1:
  //       return (
  //         <AddMoneyNew
  //           handleClose={handleClose}
  //           setStepAddMoney={setStepAddMoney}
  //         />
  //       );
  //     case 2:
  //       return (
  //         <AddBankCard
  //           handleClose={handleClose}
  //           setStepAddMoney={setStepAddMoney}
  //         />
  //       );
  //     case 3:
  //       return (
  //         <AddBankCardOTP
  //           handleClose={handleClose}
  //           setStepAddMoney={setStepAddMoney}
  //         />
  //       );
  //     case 4:
  //       return (
  //         <AddMoneyPassword
  //           handleClose={handleClose}
  //           setStepAddMoney={setStepAddMoney}
  //         />
  //       );
  //     case 5:
  //       return (
  //         <AddMoneyAllCards
  //           handleClose={handleClose}
  //           setStepAddMoney={setStepAddMoney}
  //         />
  //       );
  //   }
  // };

  // const withdrawModal = () => {
  //   switch (stepWithdraw) {
  //     case 1:
  //       return (
  //         <Withdrawal
  //           handleClose={handleClose}
  //           setStepWithdraw={setStepWithdraw}
  //         />
  //       );
  //     case 2:
  //       return (
  //         <WithdrawalOTP
  //           handleClose={handleClose}
  //           setStepWithdraw={setStepWithdraw}
  //         />
  //       );
  //     case 3:
  //       return (
  //         <WithdrawalSuccess
  //           handleClose={handleClose}
  //           setStepWithdraw={setStepWithdraw}
  //         />
  //       );
  //   }
  // };

  const onPageChange = (event, value) => {
    setFilters((prev) => ({ ...prev, page: value }));
  };

  //console.log("payments-card", histories);

  return (
    <div className="payment-container">
      <h2>Payment</h2>

      <div className="payment-content">
        <div className="box-container">
          {user?.account_type === "individual" ? (
            <PaymentCard
              label={"Received Payment"}
              amount={_currency_format(
                Number(cards?.data?.recieved_payment ?? 0),
                "NGN"
              )}
            />
          ) : null}
          {user?.account_type === "organisation" && (
            <PaymentCard
              label="Pending Refund"
              amount={_currency_format(
                Number(cards?.data?.pending_refund ?? 0),
                "NGN"
              )}
            />
          )}
          <PaymentCard
            label={"Total Payout"}
            amount={_currency_format(
              Number(cards?.data?.total_payout ?? 0),
              "NGN"
            )}
          />
        </div>

        <div>
          {/* <PaymentSection
            subTitle="where your earning would be credited into"
            btnTitle={"Add account"}
            showmodal={() => setShowSetup(true)}
          /> */}

          <PaymentSection
            accNo={
              account?.data ? account?.data?.account_number : "ADD ACCOUNT"
            }
            subTitle={account?.data && account?.data?.bank_name}
            btnTitle={
              account?.data?.account_number ? "Edit Account" : "Add Account"
            }
            showmodal={() => setShowSetup(true)}
            loading={isAccounting}
          />
        </div>

        <div className="payment-bottom">
          <div className="nav-payment">
            <div style={{ maxWidth: "350px" }}>
              {user?.account_type === "individual" ? (
                <CustomAutoComplete
                  isClearable={false}
                  options={options}
                  initOption={initOption}
                  customStyles={{
                    control: {
                      maxWidth: "100%",
                      borderRadius: "0",
                    },
                    valueContainer: {
                      height: "45px",
                    },
                  }}
                  onChange={(option) => {
                    setFilters((prev) => ({
                      ...prev,
                      pay_type: option?.value,
                    }));
                  }}
                />
              ) : (
                <h3 style={{ textTransform: "uppercase", color: " #245293" }}>
                  Payout History
                </h3>
              )}
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                flexWrap: "wrap",
              }}
            >
              <div className="custom-select">
                <CustomAutoComplete
                  isClearable={false}
                  options={statusOptions}
                  customStyles={{
                    control: {
                      maxWidth: "100%",
                      borderRadius: "0",
                    },
                    valueContainer: {},
                  }}
                  placeholder="Select Status"
                  onChange={(option) => {
                    setFilters((prev) => ({
                      ...prev,
                      payment_status: option?.value,
                    }));
                  }}
                />
              </div>
              <div className="date-bg">
                <div>
                  <input
                    type="date"
                    value={filters.date_from}
                    onChange={(e) =>
                      setFilters((prev) => ({
                        ...prev,
                        date_from: e.target.value,
                      }))
                    }
                    style={{
                      padding: "8px",
                      border: "1px solid #efefef",
                      borderRadius: "0",
                      minHeight: "45px",
                    }}
                  />
                </div>

                <span>To</span>

                {/* Date To */}
                <div>
                  <input
                    type="date"
                    value={filters.date_to}
                    onChange={(e) =>
                      setFilters((prev) => ({
                        ...prev,
                        date_to: e.target.value,
                      }))
                    }
                    style={{
                      padding: "8px",
                      border: "1px solid #efefef",
                      borderRadius: "0",
                      minHeight: "45px",
                    }}
                  />
                </div>
              </div>

              <Button
                onClick={() => {
                  setFilters((prev) => ({
                    ...prev,
                    page: 1,
                    date_from: "",
                    date_to: "",
                  }));
                }}
                style={{
                  backgroundColor: "transparent",
                  border: "1px solid #D3D3D3",
                  height: "45px",
                  minWidth: "30px",
                }}
              >
                <GrPowerReset />
              </Button>
            </div>
          </div>

          <PaginationContainer
            loading={isRetriving}
            data={paymentHistory}
            onPageChange={onPageChange}
            page={filters.page}
            total={histories?.count ?? 0}
          >
            <div className="table-container">
              <table className="table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Amount</th>
                    <th>Refunded Amount</th>
                    <th>Date</th>
                    <th>Method</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {paymentHistory?.map((i) => (
                    <tr key={i.id}>
                      <td>
                        {user?.account_type === "individual"
                          ? filters.pay_type === "payin"
                            ? i.poster_info.name
                            : i.applicant_info.name
                          : i.applicant_info.name}
                      </td>
                      {user?.account_type === "individual" ? (
                        <td>
                          {i.payment_status === "4" &&
                          filters.pay_type === "payout"
                            ? _currency_format(Number(i.job_pay), "NGN")
                            : _currency_format(Number(i.net_pay), "NGN")}
                        </td>
                      ) : (
                        <td>{_currency_format(Number(i.job_pay), "NGN")}</td>
                      )}

                      <td>
                        {_currency_format(Number(i.refunded_amount), "NGN")}
                      </td>

                      <td>{moment(i.date).format("LLL")}</td>
                      <td style={{ textTransform: "capitalize" }}>
                        {i.payment_channel}
                      </td>
                      <td>
                        <div className="status">
                          <span
                            className={
                              i.payment_status === "1"
                                ? "pend"
                                : i.payment_status === "2"
                                ? "pend"
                                : i.payment_status === "3"
                                ? "pend"
                                : i.payment_status === "4"
                                ? "succ"
                                : i.payment_status === "5"
                                ? "refund"
                                : null
                            }
                          >
                            {i.payment_status === "1"
                              ? "Pending"
                              : i.payment_status === "2"
                              ? "Pending"
                              : i.payment_status === "3"
                              ? "Pending"
                              : i.payment_status === "4"
                              ? "Processed"
                              : i.payment_status === "5"
                              ? "Refunded"
                              : null}
                          </span>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="mobile-table-con">
              {paymentHistory?.length &&
                paymentHistory?.map((i) => (
                  <div key={i.id} className="mobile-single-table">
                    <div className="cols-mobile">
                      <h6>Amount</h6>
                      <p>{_currency_format(Number(i.job_pay), "NGN")}</p>
                    </div>
                    <div className="cols-mobile">
                      <h6>Date</h6>
                      <p>{moment(i.date).format("LLL")}</p>
                    </div>
                    <div className="cols-mobile">
                      <h6>Method</h6>
                      <p style={{ textTransform: "capitalize" }}>
                        {i.payment_channel}
                      </p>
                    </div>
                    <div className="cols-mobile">
                      <h6>Status</h6>
                      <div className="status">
                        <span
                          className={
                            i.payment_status === "1"
                              ? "pend"
                              : i.payment_status === "2"
                              ? "pend"
                              : i.payment_status === "3"
                              ? "pend"
                              : i.payment_status === "4"
                              ? "succ"
                              : i.payment_status === "5"
                              ? "refund"
                              : null
                          }
                        >
                          {i.payment_status === "1"
                            ? "Pending"
                            : i.payment_status === "2"
                            ? "Pending"
                            : i.payment_status === "3"
                            ? "Pending"
                            : i.payment_status === "4"
                            ? "Processed"
                            : i.payment_status === "5"
                            ? "Refunded"
                            : null}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </PaginationContainer>

          {/* {paymentHistory.length < 1 && (
              <div className="payment-board">
                <p>No transactions recorded yet</p>
              </div>
            )} */}
        </div>

        {/* <div className="pagination-controls">
          <Button
            disabled={!histories?.data?.links?.prev}
            onClick={() =>
              setFilters((prev) => ({
                ...prev,
                page: prev.page - 1,
              }))
            }
          >
            Prev
          </Button>

          <span className="page">{histories?.data?.meta?.current_page}</span>

          <Button
            disabled={!histories?.data?.links?.next}
            onClick={() =>
              setFilters((prev) => ({
                ...prev,
                page: prev.page + 1,
              }))
            }
          >
            Next
          </Button>
        </div> */}

        <CustomDialog className="full-width-login" open={showSetup}>
          <BankAccount
            close={handleClose}
            update={!!account?.data?.account_number}
          />
        </CustomDialog>

        {/* <CustomDialog open={showAddMoney}>{addMoneyModal()}</CustomDialog>
        <CustomDialog open={showWithdraw}>{withdrawModal()}</CustomDialog> */}
      </div>
    </div>
  );
};

export default Payment;

const BankAccount = ({ close, update = false }) => {
  //console.log("is", update);
  const { banks } = usePayments();
  const { user } = useTypedSelector((store) => store.appUser);
  const [verifyAccount, { isLoading: isVerifying }] =
    useLazyVerifyAccountQuery();
  const [addBankAccount, { isLoading: isAdding }] = useAddBankAccountMutation();
  const [updateBankAccount, { isLoading: isUpdating }] =
    useUpdateBankAccountMutation();
  const [addName, setAddName] = useState(false);
  const [details, setDetails] = useState({
    user_id: user?.id,
    account_name: "",
    account_number: "",
    bank_name: "",
    bank_code: null,
  });

  const handleVerifyAcc = async () => {
    const { data } = await verifyAccount({
      acc_no: Number(details.account_number),
      bank_code: Number(details.bank_code),
    });

    if (data.status) {
      setDetails((prev) => ({ ...prev, account_name: data.data.account_name }));
      setAddName(false);
      toast.success(data.message);
    } else {
      toast.error("Add Account Name");
      setAddName(true);
    }
  };

  const handleAddAcc = async () => {
    const res = await addBankAccount({
      ...details,
      acc_type: user?.account_type,
    });
    if (res?.data?.status) {
      close();
      toast.success(res.data.message);
    } else {
      toast.error("Failed to Add Account");
    }
  };

  const handleUpdateAcc = async () => {
    const res = await updateBankAccount({
      ...details,
      acc_type: user?.account_type,
      _method: "PUT",
    });
    if (res?.data?.status) {
      close();
      toast.success(res.data.message);
    } else {
      toast.error("Failed to Add Account");
    }
  };

  const disable =
    details?.account_number.length <= 7 || details?.bank_code === null;

  return (
    <div className="modal-container-inner">
      <ModalHeader title="Bank Account" onClose={close} />

      <div className="warning-acc">
        <p>
          Your account details must match your registered name on our website to
          ensure seamless transactions.
        </p>
      </div>

      <div className="input-modal-cover">
        {details?.account_name.length && !addName ? (
          <ProfileEditInput
            label="Account Name"
            widthCon="100%"
            width="100%"
            value={details.account_name}
            readOnly
            customLabelStyles={{
              color: "#021424",
              fontWeight: 600,
            }}
            customInputStyles={{
              height: 55,
              fontSize: 16,
              fontWeight: 500,
              borderRadius: "0px",
              textTransform: "uppercase",
              border: "1px solid green",
              backgroundColor: "rgb(222, 250, 222)",
              color: "green",
            }}
          />
        ) : null}
        {addName ? (
          <ProfileEditInput
            label="Account Name"
            placeholder="Account Name"
            widthCon="100%"
            width="100%"
            value={details.account_name}
            onChange={(e) => {
              setDetails((prev) => ({ ...prev, account_name: e.target.value }));
            }}
            customLabelStyles={{
              color: "#021424",
              fontWeight: 600,
            }}
            customInputStyles={{
              height: 55,
              fontSize: 16,
              fontWeight: 500,
              borderRadius: "0px",
              textTransform: "uppercase",
            }}
          />
        ) : null}
        <div className="auto-complete-con">
          <CustomAutoComplete
            isClearable={false}
            label="Bank name"
            placeholder="Bank name"
            customLabelStyles={{
              color: "#021424",
              fontWeight: 600,
            }}
            customStyles={{
              valueContainer: {
                paddingTop: "11px",
                paddingBottom: "11px",
              },
            }}
            options={banks}
            onChange={(e) =>
              setDetails((prev) => ({
                ...prev,
                bank_name: e.label,
                bank_code: e.value,
              }))
            }
          />
        </div>
        <ProfileEditInput
          label="Account number"
          placeholder="Account number"
          widthCon="100%"
          width="100%"
          type="number"
          value={details.account_number}
          customLabelStyles={{
            color: "#021424",
            fontWeight: 600,
          }}
          customInputStyles={{
            height: 55,
            fontSize: 16,
            fontWeight: 500,
            borderRadius: "50px",
          }}
          onChange={(e) =>
            setDetails((prev) => ({
              ...prev,
              account_number: e.target.value,
            }))
          }
        />
      </div>

      <div>
        <CustomButton
          customStyles={{
            width: "100%",
            height: "40px",
            marginTop: "0",
            fontSize: "14px",
            borderRadius: "5px",
          }}
          loading={isVerifying || isAdding || isUpdating}
          onClick={() =>
            details.account_name.length
              ? update
                ? handleUpdateAcc()
                : handleAddAcc()
              : handleVerifyAcc()
          }
          disable={disable || isVerifying || isAdding || isUpdating}
          title={
            details.account_name.length
              ? update
                ? "Update"
                : "ADD"
              : "VERIFY ACCOUNT"
          }
        />
      </div>
    </div>
  );
};
